export const HOTJAR_EVENTS = {
  HEATMAP_ACCURATE: 'heatmap_accurate',
  HEATMAP_INACCURATE: 'heatmap_inaccurate',
  HEATMAP_RATE: 'heatmap_rate',
  HEATMAP_REFRESH: 'heatmap_refresh',
  HEATMAP_TAKENEW: 'heatmap_takenew',
};
